import React from "react";
import { Link } from "react-router-dom";
import { IoPersonCircleOutline as AuthorIcon } from "react-icons/io5";
import ReactTimeAgo from "react-time-ago";
import styles from "./Article.module.css";
import { removeFirstWord } from "../../utilities/dataManipulation";
import imgPlaceholder from "../../assets/images/placeholder.jpg";

const getBase = () =>
  process.env.REACT_APP_TEST_MODE === "true"
    ? ""
    : process.env.REACT_APP_S3_BASE_URL || "";

export const Article = React.memo(({ article, articleType }) => {
  const { title, abstract, date, section, author, slug, url } = article;

  // if article has no title or abstract don't display it
  if (!title || !abstract) {
    return null;
  }

  const isInternal = url?.startsWith("/");
  const articleEl = (
    <article
      className={` ${
        articleType === "main"
          ? styles.main_article
          : styles.filtered_article
      }`}
    >
      <section className={styles.article_info}>
        <p className={styles.date}>
          {date}
          {Date.parse(date) ? (
            <> (<ReactTimeAgo date={Date.parse(date)} locale="en-US" />)</>
          ) : null}
        </p>
        <div className={styles.text_block}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.section_name}>{section?.toUpperCase()}</p>
          <p className={styles.abstract}>{article.abstract}</p>
          {author && (
            <div className={styles.author}>
              <AuthorIcon className={styles.author_icon} />
              <p>{removeFirstWord(author)}</p>
            </div>
          )}
        </div>
      </section>

      <img
        className={styles.article_img}
        src={`${getBase()}/content/images/${slug}.png`}
        alt={title}
        onError={(e) => { e.target.src = imgPlaceholder; }}
      />
    </article>
  );

  return (
    <div className={`${styles.card_link} ${article.isNew ? styles.fadeIn : ''}`}>
      {isInternal ? (
        <Link to={url}><div>{articleEl}</div></Link>
      ) : (
        <a href={url} target="_blank" rel="noreferrer">{articleEl}</a>
      )}
    </div>
  );
});
